import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {META_REDUCERS, StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '../environments/environment';
import {EffectsModule} from '@ngrx/effects';
import {EffectsActions} from './state/effects.actions';
import {financeStateId} from './state/AppState';
import {reducerConfigEvents, reducerEvents} from './state/reducer.events';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GraphComponent} from './mortgage/graph/graph.component';
import {SummaryComponent} from './mortgage/summary/summary.component';
import {CollectedMaterialModule} from './material.module';
import {ScenarioComponent} from './mortgage/scenario/scenario.component';
import {DetailsComponent} from './mortgage/details/details.component';
import {PaymentComponent} from './mortgage/payment/payment.component';
import {MyNgxChartDirective} from './mortgage/graph/graph.directive';
import {FirebaseTSApp} from 'firebasets/firebasetsApp/firebaseTSApp';
import {AnalyticsService} from './common/analytics.service';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {BtcDonationDialogComponent} from './btc/btc.component';
import {LocalStorageActionService} from './local-storage-action.service';
import {getMetaReducersFactory} from './storage.metareducer';
import {FlexLayoutModule} from '@angular/flex-layout';
import {PaymentsDialogComponent} from "./payments/payments.component";
import {MatBadgeModule} from "@angular/material/badge";
import {FeatureDialogComponent} from "./featureRequest/feature.component";
import {HelpDialogComponent} from "./help/help.component";

@NgModule({
  declarations: [
    AppComponent,
    GraphComponent,
    SummaryComponent,
    ScenarioComponent,
    DetailsComponent,
    PaymentComponent,
    BtcDonationDialogComponent,
    FeatureDialogComponent,
    PaymentsDialogComponent,
    HelpDialogComponent,
    MyNgxChartDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    MatBadgeModule,
    CollectedMaterialModule,
    StoreModule.forRoot({
      [financeStateId]: reducerEvents,
      config: reducerConfigEvents,
    }),
    EffectsModule.forRoot([EffectsActions]),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: environment.production}),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),

    // for ngx-charts
    NgxChartsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {provide: AnalyticsService, useClass: AnalyticsService},
    {
      provide: META_REDUCERS,
      deps: [LocalStorageActionService],
      useFactory: getMetaReducersFactory,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
    const firebaseConfig = {
      apiKey: 'AIzaSyB7o7PXlbpO_tG13ujpIEaVlTJ36KuhtuQ',
      authDomain: 'mortgage-comparinator.firebaseapp.com',
      databaseURL: 'https://mortgage-comparinator.firebaseio.com',
      projectId: 'mortgage-comparinator',
      storageBucket: 'mortgage-comparinator.appspot.com',
      messagingSenderId: '708298204726',
      appId: '1:708298204726:web:0992f3d9e0c927e704da97',
      // measurementId: 'G-ZFPEYCV4MY'
      measurementId: 'G-27F2K4RGC9'
    };
    FirebaseTSApp.init(firebaseConfig);
  }
}
